/**
 * 管理画面（閾値編集）右プレビュー: グラフ種別 → 本番と同じ get-graph アクション
 */
export const ACTION_GROUP_PREVIEW_CONFIG = {
  prediction: { kind: 'prediction', graphAction: null },
  calendar: { kind: 'graph', graphAction: 'cal_cog' },
  heatmap_week_time: { kind: 'graph', graphAction: 'wti_cog' },
  heatmap_date_time: { kind: 'graph', graphAction: 'dti_cog' },
  trend_year: { kind: 'trend', graphAction: 'year_trend' },
  trend_month: { kind: 'trend', graphAction: 'month_trend' },
  trend_week: { kind: 'trend', graphAction: 'week_trend' },
  event_effect_hourly: { kind: 'event_effect', graphAction: 'event_effect' },
  default: { kind: 'graph', graphAction: 'cal_cog' },
};

/** プレビュー用の日付 UI（月選択 vs 日選択） */
export const ACTION_GROUP_PREVIEW_UNIT = {
  prediction: 'day',
  calendar: 'month',
  heatmap_week_time: 'month',
  heatmap_date_time: 'month',
  trend_year: 'month',
  trend_month: 'month',
  trend_week: 'month',
  event_effect_hourly: 'day',
  default: 'month',
};

export function getPreviewConfig(actionGroup) {
  return ACTION_GROUP_PREVIEW_CONFIG[actionGroup] || ACTION_GROUP_PREVIEW_CONFIG.default;
}

export function getPreviewUnit(actionGroup) {
  return ACTION_GROUP_PREVIEW_UNIT[actionGroup] || ACTION_GROUP_PREVIEW_UNIT.default;
}

const EMPTY_DASHBOARD_STATE = {
  data: null,
  calendarData: [],
  aiAdvice: null,
  weatherData: [],
  eventData: [],
  previousMonthCalendarData: [],
  previousMonthWeatherData: [],
  previousMonthEventData: [],
  previousYear: null,
  previousMonth: null,
  predictionMeta: null,
  responseType: null,
  loading: false,
  error: null,
};

/** POST /api/get-graph のレスポンスを useDashboardData 互換に変換 */
export function graphResponseToDashboardState(response, action) {
  if (!response) {
    return { ...EMPTY_DASHBOARD_STATE };
  }

  const base = {
    aiAdvice: response?.ai_advice || null,
    weatherData: response?.weather_data || [],
    eventData: response?.event_data || [],
    previousMonthCalendarData: response?.previous_month_data || [],
    previousMonthWeatherData: response?.previous_month_weather_data || [],
    previousMonthEventData: response?.previous_month_event_data || [],
    previousYear: response?.previous_year ?? null,
    previousMonth: response?.previous_month ?? null,
    predictionMeta: response?.prediction_meta || null,
    loading: false,
    error: null,
  };

  if (['year_trend', 'month_trend', 'week_trend'].includes(action)) {
    return {
      ...base,
      data: response?.data ?? [],
      calendarData: [],
      responseType: action,
    };
  }

  if (action === 'event_effect') {
    return {
      ...base,
      data: response?.data ?? null,
      calendarData: [],
      responseType: null,
    };
  }

  return {
    ...base,
    data: null,
    calendarData: response?.data || [],
    responseType: null,
  };
}
